var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomoMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#31363F",
    stroke: "#DFE4EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1112 21.9682H21.9683H18.9207H9.77783V18.9206H18.9207L21.9683 18.9206L31.1112 18.9206V21.9682Z",
    fill: "#DFE4EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomoMinus);
export default __webpack_public_path__ + "static/media/atomoMinus.4f13cbba0699aadff0b78ee4fc05befa.svg";
export { ForwardRef as ReactComponent };